import { getWidgetsData } from 'store/selectors';

export const getPartnerDetails = (state) => getWidgetsData(state).partnerSettings || {};
